module.exports = __webpack_public_path__ + "zvetseni-prsou_42_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_42_before.jpg
// module id = 1338
// module chunks = 0